import React from "react";
import { useField } from "formik";
import {
  CountryAutocompleteField,
  ICountryAutoCompleteFieldValue,
} from "common/fields/countryAutoCompleteField/CountryAutocompleteField";

interface IFormikPreviewCountryFieldProps {
  name: string;
  labelledById?: string;
}
export const FormikPreviewCountryField: React.FC<
  IFormikPreviewCountryFieldProps
> = ({ name, labelledById }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  const setValue = (value: ICountryAutoCompleteFieldValue | null) => {
    value && helpers.setValue(JSON.stringify(value));
  };

  const value = field.value
    ? (JSON.parse(field.value) as ICountryAutoCompleteFieldValue)
    : null;
  return (
    <CountryAutocompleteField
      value={value}
      setValue={(value) => setValue(value)}
      labelledById={labelledById}
      errorMessage={meta.error}
      touched={meta.touched}
    />
  );
};
